export const GET_MESSAGE_DT = 'GET_MESSAGE_DT'
export const GET_MESSAGE_DT_OK = 'GET_MESSAGE_DT_OK'
export const GET_MESSAGE_DT_ERR = 'GET_MESSAGE_DT_ERR'
export const DO_MESSAGE_DT_CLEANUP = 'DO_MESSAGE_DT_CLEANUP'

export const CREATE_MESSAGE = 'CREATE_MESSAGE'
export const CREATE_MESSAGE_OK = 'CREATE_MESSAGE_OK'
export const CREATE_MESSAGE_ERR = 'CREATE_MESSAGE_ERR'